import { createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
    summaryLoading: false,
    summaryData: null,
    summaryError: null,

    downlineLoading: false,
    downlineData: null,
    downlineError: null,

    earningsLoading: false,
    earningsData: null,
    earningsError: null,
}

export const referralSlice = createSlice({
    name: "referral",
    initialState,
    reducers: {
        summaryRequest: (s) => { s.summaryLoading = true; s.summaryError = null },
        summarySuccess: (s, a) => { s.summaryLoading = false; s.summaryData = a.payload },
        summaryFail: (s, a) => { s.summaryLoading = false; s.summaryError = a.payload },

        downlineRequest: (s) => { s.downlineLoading = true; s.downlineError = null },
        downlineSuccess: (s, a) => { s.downlineLoading = false; s.downlineData = a.payload },
        downlineFail: (s, a) => { s.downlineLoading = false; s.downlineError = a.payload },

        earningsRequest: (s) => { s.earningsLoading = true; s.earningsError = null },
        earningsSuccess: (s, a) => { s.earningsLoading = false; s.earningsData = a.payload },
        earningsFail: (s, a) => { s.earningsLoading = false; s.earningsError = a.payload },
    },
})

export const {
    summaryRequest, summarySuccess, summaryFail,
    downlineRequest, downlineSuccess, downlineFail,
    earningsRequest, earningsSuccess, earningsFail,
} = referralSlice.actions

export const doGetReferralSummary = () => async (dispatch) => {
    dispatch(summaryRequest())
    try {
        const res = await axios.get(`/api/customer/referral/summary`)
        dispatch(summarySuccess(res.data.data))
    } catch (e) {
        dispatch(summaryFail(e.response?.data?.message || e.message || "Network error"))
    }
}

export const doGetReferralDownline = () => async (dispatch) => {
    dispatch(downlineRequest())
    try {
        const res = await axios.get(`/api/customer/referral/downline`)
        dispatch(downlineSuccess(res.data.data))
    } catch (e) {
        dispatch(downlineFail(e.response?.data?.message || e.message || "Network error"))
    }
}

export const doGetReferralEarnings = (params = {}) => async (dispatch) => {
    dispatch(earningsRequest())
    try {
        const query = new URLSearchParams(params).toString()
        const res = await axios.get(`/api/customer/referral/earnings?${query}`)
        dispatch(earningsSuccess(res.data))
    } catch (e) {
        dispatch(earningsFail(e.response?.data?.message || e.message || "Network error"))
    }
}

export const getReferralSummaryData = (s) => s.referral.summaryData
export const getReferralSummaryLoading = (s) => s.referral.summaryLoading
export const getReferralDownlineData = (s) => s.referral.downlineData
export const getReferralDownlineLoading = (s) => s.referral.downlineLoading
export const getReferralEarningsData = (s) => s.referral.earningsData
export const getReferralEarningsLoading = (s) => s.referral.earningsLoading

export default referralSlice.reducer
